import { createApi } from '@reduxjs/toolkit/query/react';
import { AxiosRequestConfig } from 'axios';

import { getCeId } from '@/utils/auth';
import { apiBaseUrl, rawApi } from './rawApi';

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params, headers }: AxiosRequestConfig) => {
    try {
      const isFormData =
        typeof FormData !== 'undefined' && data instanceof FormData;
      let _data = data;
      if (isFormData) {
        const ce = getCeId();
        if (ce) {
          (data as FormData).append('ce_id', ce);
        }
        _data = data;
      } else if (
        method?.toLowerCase() === 'post' ||
        method?.toLowerCase() === 'put' ||
        method?.toLowerCase() === 'patch'
      ) {
        _data = { ...(data || {}), ce_id: getCeId() };
      }

      const result = await rawApi.request({
        url: baseUrl + url,
        method,
        data: _data,
        params,
        headers: {
          ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
          ...headers,
        },
      });

      return { data: result.data };
    } catch (axiosError: any) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

const TAG_TYPES = [
  'Seller Main',
  'Seller Dashboard',
  'Seller Product',
  'Seller Contract',
  'Seller',
  'Property',
  'Product',
  'Contract',
  'Contract Agent',
  'Contract Seller',
  'Loan Officer',
  'Negotiation',
  'Addendum',
  'User',
  'Admin User',
  'Admin Agent',
  'Admin Product',
  'Admin Email',
  'InterestRates',
  'InterestRateHistory',
  'ClauseProperties',
  'ClauseHistory',
  'NegotiationSummary',
  'PendingNegotiations',
  'Proposal',
  'ProposalSummary',
  'AgreeableClause',
  'ContractPriorities',
  'UserInterestRates',
  'Subscription',
  'Message',
  'Email Notification',
  'User Email Preferences',
  'RateAlerts',
  'ContractDocuments',
  'ContractTasks',
  'ContractPipeline',
  'ContractActivity',
  'ClosingOrchestration',
  'AddendumTemplates',
  'BuyerDocumentRequests',
  'LoanApplication',
  'LoanApplicationDocuments',
  'DocumentRequirements',
  'LoanChecklistMatrices',
  'ClauseDictionary',
] as const;

export const rtkApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({ baseUrl: apiBaseUrl }),
  tagTypes: TAG_TYPES,
  endpoints: (_builder) => ({}),
});

/**
 * Refetch everything after the signed-in account changes in this tab, so
 * nothing cached for the previous account (a loan file, a property) lingers.
 */
export const refetchAllForNewAccount = () =>
  rtkApi.util.invalidateTags([...TAG_TYPES]);
